<template>
    <div>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-form ref="viewAllHsft" v-model="reviveHsftValid">
            <v-card-title class="justify-center">View all photo's {{ huisall.huis_code }}</v-card-title>
            <v-divider/>
            <div class="scrollable" v-if="!loading">
                <v-row no-gutters>
                    <v-col v-for="p in huisall.hsft_aant" :key="p" id="content" class="pa-2" cols=2>
                        <figure :class="(huisall.hsft[parseInt(p) - 1].fttgtaal_oms !== '' && huisall.hsft[parseInt(p) - 1].hsft_status == 'Live') ? huisall.hsft[parseInt(p) - 1].hsft_status : (huisall.hsft[parseInt(p) - 1].fttgtaal_oms == '' && huisall.hsft[parseInt(p) - 1].hsft_status !== 'Live') ? huisall.hsft[parseInt(p) - 1].hsft_status : (huisall.hsft[parseInt(p) - 1].fttgtaal_oms !== '' && huisall.hsft[parseInt(p) - 1].hsft_status !== 'Live') ? huisall.hsft[parseInt(p) - 1].hsft_status : 'LiveNoTag'">

                            <img :src="huisall.hsft[parseInt(p) - 1].hsft_foto" class="px-1" :title="huisall.hsft[parseInt(p) - 1].hsft_tag" @click="updHsftAll(huisall.hsft[parseInt(p) - 1].hsft_encrid)">
                            <figcaption >{{ huisall.hsft[parseInt(p) - 1].hsft_nr }} 
                                {{ huisall.hsft[parseInt(p) - 1].fttgtaal_oms }} 
                                <br>
                                <v-chip outlined color="warning" v-if="huisall.hsft[parseInt(p) - 1].hsft_photographer !== ''" small>
                                    <v-icon left x-small>
                                        mdi-camera
                                    </v-icon> {{ huisall.hsft[parseInt(p) - 1].hsft_photographer }}
                                </v-chip>
                                <v-chip outlined color="error" v-if="huisall.hsft[parseInt(p) - 1].not_unique_huis_code !== ''" small>
                                    <v-icon left x-small>
                                        mdi-alert-circle-outline
                                    </v-icon> photo not unique
                                </v-chip>
                                
                                <span>{{ huisall.hsft[parseInt(p) - 1].uploaded }}</span>
                            </figcaption>
                            <div>
                            <v-btn v-if="huisall.hsft[parseInt(p) - 1].hsft_status == 'Live'" x-small color="primary" @click="setOffline(huisall.hsft[parseInt(p) - 1].hsft_encrid,(parseInt(p) - 1))">set offline</v-btn>
                            <v-btn v-if="huisall.hsft[parseInt(p) - 1].hsft_status == 'Offline'" x-small color="primary" @click="setOnline(huisall.hsft[parseInt(p) - 1].hsft_encrid,(parseInt(p) - 1))">set online</v-btn>
                            <v-btn v-if="huisall.hsft[parseInt(p) - 1].hsft_status == 'Offline'" x-small color="red" @click="deletePhoto(huisall.hsft[parseInt(p) - 1].hsft_encrid,(parseInt(p) - 1))"><v-icon small color="white">mdi-trash-can</v-icon></v-btn>
                            <v-btn x-small color="grey" :href="huisall.hsft[parseInt(p) - 1].hsft_foto_download" target="_blank" download><v-icon small color="white">mdi-download</v-icon></v-btn>
                            </div>
                            <!-- <v-checkbox v-model="selected" :value="huisall.hsft[parseInt(p) - 1].hsft_encrid" :rules="selected_checks" label="Back to live" class="my-0"></v-checkbox> -->
                        </figure>                         
                    </v-col>
                </v-row>
            </div>
            <v-skeleton-loader v-if="loading" class="mx-auto" max-width="1000" type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
            <v-divider/>
            </v-form>
            <v-card-actions>
                <v-chip class="Live">Live</v-chip> &nbsp;
                <v-chip class="LiveNoTag">Live No Tag</v-chip> &nbsp;
                <v-chip class="Offline">Offline</v-chip>
                <v-spacer/>
                <v-btn color="primary" small @click="closeDelDialog()">Close</v-btn>
            </v-card-actions>
        
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbigdel" width="600px">
        <v-card>
            <p class=".title ma-2">{{ huisall.huis_code }} </p>
            <v-img :src="this.bigimage" width="600" height="450"></v-img>
            <v-container>
                <v-row dense class="flex">
                    <v-spacer />
                <v-btn color="primary" small @click="dialogbigdel = false">Close</v-btn>
            </v-row>
            </v-container>
        </v-card>
    </v-dialog>
    <updHsftAll ref="updHsftAll" @updateData="updateData"></updHsftAll>
    <delHsft ref="delHsft" @updateData="updateData"></delHsft>
    </div>
</template>

<script>
    // import { bus } from "../../../main";
    import updHsftAll from "@/views/huis/hsft/updHsftAll.vue";
    import delHsft from "@/views/huis/hsft/delHsft.vue";

    export default {
            components: {
                updHsftAll,
                delHsft
        },
        data() { 
            return {
                dialog: false,
                huis_encrid: null,
                dialogbigdel: false,
                bigimage: null,
                reviveHsftValid: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huisall: {},
                selected: [],
                message: "",
                delCounter: 0,
                selected_checks: [
                    v => (v || '').length > 0 || 'Choose at least 1 photo to revive',
                ],
                items: [],
                isLoading: false,
                model: null,
                search: null,
                loading: false,
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        methods: {
            open(huis_encrid) {
                this.loading = true;
                this.huis_encrid = huis_encrid;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.$axios
                .post("ares/json/ares/huis/hsft/getAllHsft.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAllHsft"
                },
                getAllHsft: {
                    huis_encrid: huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.huisall = res.data.getAllHsft;
                }
                })
                .finally(() => {
                    this.selected = [];
                    this.loading = false;
                });
            },
            selectAll() {
                this.selected = [];
                for (let i=0; i < this.huisall.hsft.length; i++) {
                    this.selected.push(this.huisall.hsft[i].hsft_encrid);
                }            
            },
            clearAll() {
                this.selected = [];          
            },
            updHsftAll(hsft_encrid) {
                this.$refs.updHsftAll.open(hsft_encrid);
            },  
            closeDelDialog() {
                this.dialog = false;
            },
            copyHsftConfirmCountdown() {
                this.confirmCounter -= 1;
                if (this.confirmCounter <= 0) {
                    clearInterval(this.confirmTimer);
                }
            },
            copyHsftConfirm() {
                this.confirmCounter = 5;
                this.confirmTimer = setInterval(this.copyHsftConfirmCountdown, 1000);
            },
            opendialogbigdel(bigimage) {
                this.bigimage = bigimage;
                this.dialogbigdel = true;
            },
            updateData() {
                this.$emit("updateData");
                this.$axios
                .post("ares/json/ares/huis/hsft/getAllHsft.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAllHsft"
                },
                getAllHsft: {
                    huis_encrid: this.huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.huisall = res.data.getAllHsft;
                }
                })
                .finally(() => {
                    this.selected = [];
                    this.loading = false;
                });
            },
            setOffline(photoid,index){
                    this.$axios.post("ares/json/ares/huis/hsft/saveHsftStat.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHsftStat"
                    },
                    saveHsftStat: {
                        hsft_encrid: photoid,
                        hsft_status: "Offline"
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHsftStat.text,
                            color: res.data.saveHsftStat.color
                        });
                        this.huisall.hsft[index].hsft_status = "Offline";
                        // if (res.data.saveHsftStat.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.clearAll();
                        this.$emit('updateData');
                    }
                    this.message = "";
                })
                console.log(photoid);
            },
            setOnline(photoid,index){
                this.$axios.post("ares/json/ares/huis/hsft/saveHsftStat.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHsftStat"
                    },
                    saveHsftStat: {
                        hsft_encrid: photoid,
                        hsft_status: "Live"
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHsftStat.text,
                            color: res.data.saveHsftStat.color
                        });
                        this.huisall.hsft[index].hsft_status = "Live";
                        // if (res.data.saveHsftStat.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.clearAll();
                        this.$emit('updateData');
                    }
                    this.message = "";
                })
                console.log(photoid,index);
            },
            downloadPhoto(url,label){
                this.$axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = label
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
            },
            deletePhoto(photoid,index){
                this.$refs.delHsft.open(photoid,index,this.huisall.hsft[index].hsft_grote_foto);  
            },
            reviveHsft() {
                this.confirmCounter = 0;
                //clearInterval(this.confirmTimer);
                this.message = "Please wait: Reviving photo's";
                this.$axios.post("ares/json/ares/huis/hsft/reviveHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "reviveHsft"
                    },
                    reviveHsft: {
                        hsft_encrids: this.selected,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.reviveHsft.text,
                            color: res.data.reviveHsft.color
                        });
                        // if (res.data.reviveHsft.color == "success") { 
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.clearAll();
                        this.$emit('updateData');
                        this.dialog = false;
                        this.reviveHsftValid = false;
                    }
                    this.message = "";
                })
            },
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .Live {
        background-color: rgb(218, 255, 218) !important;
        border-radius:10px;
    }
    .Offline {
        background-color: rgb(212, 212, 212) !important;
        border-radius:10px;
    }
    .Deleted {
        background-color: rgb(212, 212, 212) !important;
        border-radius:10px;
    }
    .LiveNoTag {
        background-color: rgb(255, 211, 169) !important;
        border-radius:10px;
    }
    figure{
        place-items: center;
        display: grid;
    }
</style>
